//Changes merged 27-06-25 
import React, { useState } from "react";
import { OpenAIClient, AzureKeyCredential } from "@azure/openai";
import { Spinner, SpinnerSize, Icon } from "@fluentui/react";
import { ChevronRightRegular, ChevronDownRegular} from '@fluentui/react-icons';
import './Home.css';
import { CopilotExtractText } from "./Generators/CopilateTextExtractor";
import { fetchAllTextFromWord } from "../Utils/CommonFunctions";

const MissingClauseExtractor = () => {
  const [clauseLoader, setClauseLoader] = useState(false);
  const [missingClauses, setMissingClauses] = useState([]);
  const [expandedItems, setExpandedItems] = useState({});
  const [usedIcon, setUsedIcon] = React.useState({});
  const AzureAI:any= JSON.parse(localStorage.getItem("AzureAI")||"{}")
  const endpoint =AzureAI?.Endpoint //"https://clmai.openai.azure.com/";
  const azureApiKey =AzureAI?.APIkey // "C9S9ksGyYrdvO0womECNX5OecmEpf6fOeesgVQJ5H7w3RNQtOMHJJQQJ99AKACYeBjFXJ3w3AAABACOGkAw9";
  const deploymentName = AzureAI?.DeploymentName//"gpt-35-turbo";
  const Copilot:any= JSON.parse(localStorage.getItem("Copilot")||"{}")
  React.useEffect(() => {
    fetchMissingClauses();
  }, []); 
  const fetchMissingClauses = async () => {
    try {
      setClauseLoader(true);
      let missing;
      const documentText = await fetchAllTextFromWord();
      if (Copilot?.CopilotToggle === "Yes") {
        const missingResponse = await CopilotExtractText(documentText, "Missing Clause");
        try {
          const parsed = JSON.parse(missingResponse);
          if (parsed) {
            missing = JSON.parse(missingResponse)?.missing;
          }
        } catch (e) {
          setMissingClauses([]);
          console.log("Non result:", missingResponse);
        }
      } else if (AzureAI?.AzureOpenAIToggle) {
        const result = await generateKeyValuePairsWithInference(documentText);
        missing = result?.missing;
      }
      if (missing) {
        const missingClauses = Object.entries(missing).map(([key, value]) => ({
          [key]: value || "-",
        }));
        setMissingClauses(missingClauses);
      } else {
        setMissingClauses([]);
      }
    } catch (error) {
      console.error("Error fetching missing clauses:", error);
    } finally {
      setClauseLoader(false);
    }
  };
  
const generateKeyValuePairsWithInference = async (documentText) => {
    const client = new OpenAIClient(endpoint, new AzureKeyCredential(azureApiKey));

    const messages = [
      { role: 'system', content: 'You are an assistant that extracts key-value pairs from documents and infers missing ones.' },
      { role: 'user', content: `Extract all clauses from the following text and infer any missing ones. Provide the output with "extracted" and "missing" clauses with details:\n\n${documentText}` },
    ];

    const response = await client.getChatCompletions(deploymentName, messages, {
      maxTokens: 1000,
      temperature: 0,
    });

    const openAIResponse = response.choices[0].message.content.trim();
    // console.log(openAIResponse,"openAIResponse");
    const cleanedResponse = openAIResponse
    .replace(/```json|```/g, "")
    .replace(/\\n/g, "")
    .trim();
    // console.log(cleanedResponse,"cleanedResponse");

  try {
    return JSON.parse(cleanedResponse);
  } catch (error) {
    console.warn("Response is not valid JSON. Attempting plain text processing.");
    const extracted = {};
    const missing = {};

    const sections = cleanedResponse.split(/(?:\n\s*)?missing(?: clauses|):?/i);
    const existingRaw = sections[0];
    const missingRaw = sections[1] || "";

    existingRaw.split("\n").forEach((line) => {
      const [key, value] = line.split(":").map((part) => part.trim());
      if (key && value) extracted[key] = value;
    });

    missingRaw.split("\n").forEach((line) => {
      const [key, value] = line.split(":").map((part) => part.trim());
      if (key && value) (missing[key]) = value;
    });

    return { extracted, missing };
  }
};

  const toggleValue = (Key) => {
    setExpandedItems((prev) => ({
      ...prev,
      [Key]: !prev[Key],
    }));
    setUsedIcon((prevIcons) => ({
       ...prevIcons,
       [Key]: prevIcons[Key] === ChevronDownRegular ? ChevronRightRegular : ChevronDownRegular,
    }));
  };


  const insertTextIntoWord = async (text: string) => {
    // console.log(text,"text")
    await Word.run(async (context) => {
      let selection = context.document.getSelection();
      selection.insertText(text, Word.InsertLocation.replace);
      await context.sync();
    });
  };

  return (
    <div>
      {clauseLoader ?(
              <div
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  height: "70vh",
                }}
              >
                <Spinner size={SpinnerSize.medium} label={"Please wait... "} /></div>
            ) : !missingClauses?.length ? (
              <div className='NoDataFound'>No data found</div>
            ) : (<div style={{paddingTop:"8px"}} className="ClauseKeyValue">
                {missingClauses?.map((item) => {
                  const key:any = Object.keys(item)[0];
                  const value = item[key];
                  const Icon = usedIcon[key] || ChevronRightRegular;
                  return (
                    <div key={key}>
                      <div className="ClauseKey">
                        <div>
                        {/* <Icon
                          className="pagination_dev_previous_next_button"
                          iconName={usedIcon[key] || "ChevronRight"}
                          onClick={() => toggleValue(key)}
                        /> */}
                        <Icon
                          style={{ fontSize: 20,marginTop:-1 }}
                          onClick={() => toggleValue(key)}
                        />
                        </div>
                        <div style={{marginTop:"-2px"}}>{(key).replaceAll("_", " ").replaceAll('**',"")}</div>
                      </div>
                      {expandedItems[key] && (
                        <div className="ClauseValue" id={key}  onClick={() => insertTextIntoWord(value?.replaceAll('**', ""))} >{(value)?.replaceAll('**',"") ? (value)?.replaceAll('**',"") : '-' }</div>
                      )}
                    </div>
                  );
                })}
              </div>)}
    </div>
  );
};

export default MissingClauseExtractor;